import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ScenarioList } from "@/components/scenarios/ScenarioList";
import { Plus } from "lucide-react";

export default function ScenariosCorporatePage() {
  return (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 gap-4">
        <div>
          <h1 className="text-3xl font-bold bg-gradient-to-r from-primary to-primary/70 bg-clip-text text-transparent">
            Scenarios
          </h1>
          <p className="text-muted-foreground mt-1">
            Browse and select exercises from the scenarios library. Immutable reports are available
            on each scenario&apos;s detail page.
          </p>
        </div>
        <div className="flex gap-2 w-full md:w-auto flex-wrap">
          <Button asChild className="w-full md:w-auto bg-primary">
            <Link to="/scenarios/new" className="flex items-center gap-2">
              <Plus className="h-4 w-4" />
              <span>Add scenario</span>
            </Link>
          </Button>
          <Button asChild className="w-full md:w-auto">
            <Link to="/scenarios/actives" className="flex items-center gap-2">
              <span>View Active Scenarios</span>
              <span className="h-4 w-4 rounded-full bg-green-500 animate-pulse" />
            </Link>
          </Button>
        </div>
      </div>
      <ScenarioList />
    </div>
  );
}
